import React from 'react'
import { TableCell } from '@mui/material'
import TableSortLabel from './TableSortLabel'

const TableHeaderSortableCell = ({ column, sort, children, ...props }) => {
  return (
    <TableCell {...props}>
      <TableSortLabel
        orderBy={sort.by}
        orderName={column.sortBy || column.name}
        onOrderByChanged={() => sort.onChange(column.name)}
        direction={sort.direction}
      >
        {children}
      </TableSortLabel>
    </TableCell>
  )
}

export default TableHeaderSortableCell
